
import Swiper from 'vux/src/components/swiper/swiper.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Divider from 'vux/src/components/divider/index.vue'


const baseList = [{
url: 'http://app.sentuxueyuan.com/#/list',
img: 'http://app.sentuxueyuan.com/statics/img/home_0.jpg',

}, {
url: 'http://app.sentuxueyuan.com/#/courselist?id=30&type=%E7%A4%BC%E4%BB%AA&pid=4',
img: 'http://app.sentuxueyuan.com/statics/img/home_01.jpg',

}]

export default {
components: {
Swiper,
SwiperItem,
GroupTitle,
XButton,
Divider,
Flexbox,
FlexboxItem
},
name: 'HelloWorld',
data() {
return {
urls: '',
msg: 'Welcome to Your Vue.js App',
demo03_list: baseList,
ly_kc: [],
ly_kcs: [],
yp_kc: '',
num: 0,
login_time: false,
hy_baogao: [],
hy_baogaos: [],
zb: '',
denglu: [{
'name': 'hbtsg01',
'password': 666888
}, {
'name': 'sdtsg01',
'password': 666888
}],
check_ip: false,
check_ips: false,
token: '',
pama: {
token: '',
time: ''
}
}
},
created() {
this.urls = this.baseURL + '?c=app_login&m=login'
var a = getUrlParam("a");
var logins = getUrlParam("login");
console.log(logins)

function getUrlParam(name) {
var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); 
var r = window.location.search.substr(1).match(reg); 
if (r != null) return unescape(r[2]);
return null; 
}
if (a) {
window.location.href = 'http://app.sentuxueyuan.com/?c=app_home&m=show1'
} else {

}
if (logins) {
let setTime = new Date().getTime() + (1000 * 60);

if(logins=='xn'){
var name = 'xianningtsg';
var password =123456;

}else if(logins=='yc'){
var name = 'yichangtsg';
var password =123456;

}else if(logins=='ez'){
var name = 'ezhoutsg';
var password =123456;

}else if(logins=='xg'){
var name = 'xiaogantsg';
var password =123456;

}else if(logins=='tj'){
var name = 'sentu@123456';
var password =123456;

}else{
var name = 'hbtsg01';
var password = 666888;
}
var form = new FormData();
form.append("phone", name);
form.append("password", password);
this.$post(this.urls, form)
.then((res) => {

if (res == 12) {
alert("密码账号错误")
} else if (res == 3) {
alert("密码账号不能为空")
} else if (res == 4) {
alert("密码账号错误")
} else if (res == 10) {
alert("密码账号错误")
} else {
console.log(res.token);
this.$cookies.set('token', res.token)
this.token = this.$cookies.get('token');
window.location.href=' http://app.sentuxueyuan.com';
}
})

}
if (this.$cookies.get('token')) {

var timestamp = Math.round(new Date().getTime() / 1000)
console.log(timestamp);
this.token = this.$cookies.get('token');
this.pama.time = timestamp;
this.pama.token = this.$cookies.get('token');
this.url = this.baseURL + '?c=app_home'
this.home();


} else {
this.url = this.baseURL + '?c=app_home'
this.home();
}

},
mounted() {






},
methods: {
kecheng() {
if (this.token !== '') {
this.$router.push({
path: '/course',
name: 'course',
})
} else {
this.$router.push({
path: '/logo',
name: 'logo',
})
}
},
sendParams() {
if (this.token !== '') {
this.$router.push({
path: '/list',
name: 'list',
})
} else {
this.$router.push({
path: '/logo',
name: 'logo',
})
}
},
cepindata() {
if (this.token !== '') {
this.$router.push({
path: '/assess',
name: 'assess',
query: {
num: 0,
}
})
} else {
this.$router.push({
path: '/logo',
name: 'logo',
})
}
},
cepindatas() {
if (this.token !== '') {
this.$router.push({
path: '/assess',
name: 'assess',
query: {
num: 1,
}
})
} else {
this.$router.push({
path: '/logo',
name: 'logo',
})
}
},
dlsit(id){

},
cepin() {
if (this.token !== '') {
this.$router.push({
path: '/assess',
name: 'assess',




query: {
num: 0,
}
})
} else {
this.$router.push({
path: '/logo',
name: 'logo',
})
}
},
shipinlist() {
if (this.token !== '') {
this.$router.push({
path: '/course',
name: 'course',




})
} else {
this.$router.push({
path: '/logo',
name: 'logo',
})
}
},
home_zb(id) {
if (this.token !== '') {
this.$router.push({
path: '/zhibovideo',
name: 'zhibovideo',




query: {
id: id,
}
})
} else {
this.$router.push({
path: '/logo',
name: 'logo',
})
}
},

home_stb(){
if (this.token !== '') {
this.$router.push({
path: '/stbbm',
name: 'stbbm',




})
} else {
this.$router.push({
path: '/logo',
name: 'logo',
})
}
},
baogaolist() {
if (this.token !== '') {
this.$router.push({
path: '/report',
name: 'report',




})
} else {
this.$router.push({
path: '/logo',
name: 'logo',
})
}
},

kec(pid, id) {
if (this.token !== '') {
this.$router.push({
path: "/video", //接收页面路由
query: {
id: id,
type: 'liyi',
pid: pid,
}
})
} else {
this.$router.push({
path: '/logo',
name: 'logo',
})
}
},
home() {


this.$get(this.url, this.pama)
.then((res) => {
console.log(res)
this.ly_kc = res.data.ly_kc;
this.login_time = res.login_time;





this.check_ip = this.$cookies.get('openid');

this.hy_baogao = res.data.hy_baogao;
console.log(this.ly_kc);
let arr1 = [];
let arr2 = [];
for (let i in this.ly_kc) {


arr1.push(this.ly_kc[i]);
}
var j = 0;
for (j = 0; j < arr1.length - 1; j++) {
arr2.push(arr1[j])
}

console.log(arr1)
console.log(arr2)
let arr3 = [];
let arr4 = [];
for (let i in this.hy_baogao) {


arr3.push(this.hy_baogao[i]);
}
var k = 0;
for (k = 0; k < arr3.length - 1; k++) {
arr4.push(arr3[k])
}

console.log(arr3)
console.log(arr4)
this.ly_kcs = arr2;
this.yp_kc = res.data.yp_kc
console.log(this.yp_kcs);
this.hy_baogaos = arr4;
this.zb = res.data.zb;
})

},
bntss() {
if (this.token !== '') {
this.$router.push({
path: '/report',
name: 'report',

})
} else {
this.$router.push({
path: '/logo',
name: 'logo',
})
}
},
jianli() {
if (this.token !== '') {
this.$router.push({
path: '/jianli',
name: 'jianli',

})
} else {
this.$router.push({
path: '/logo',
name: 'logo',
})
}
},
yinpin(id) {
if (this.token !== '') {
this.$router.push({
path: '/audio',
name: 'audio',
query: {
id: id,
}
})
} else {
this.$router.push({
path: '/logo',
name: 'logo',
})
}
},
yinpinlist() {
if (this.token !== '') {
this.$router.push({
path: '/audiolist',
name: 'audiolist',
})
} else {
this.$router.push({
path: '/logo',
name: 'logo',
})
}
},
baogao(id, pid) {
if (this.token !== '') {
this.$router.push({
path: '/reports',
name: 'reports',




query: {
year: pid,
day: id,
nian: '2019',
}
})
} else {
this.$router.push({
path: '/logo',
name: 'logo',
})
}
}
},

}



// WEBPACK FOOTER //
// ./src/components/HelloWorld.vue